import { render, staticRenderFns } from "./ListeProduitsComponent.vue?vue&type=template&id=52066736"
import script from "./ListeProduitsComponent.vue?vue&type=script&lang=js"
export * from "./ListeProduitsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports